import { FC, useCallback, useState } from "react"
import DeleteItemDialog from "src/components/shared/DeleteItemDialog"
import { IExpenseCategory } from "src/domain/entities"
import { expenseCategoryDeleteService } from "src/domain/services/expenseCategory/expenseCategoryDeleteService"
import { useAuth } from "src/hooks"
import { getErrorMessage } from "src/utils/helpers"

interface Props {
	expenseCategory: IExpenseCategory
	isOpen: boolean
	setIsOpen: (isOpen: boolean) => void
	onSuccess?: () => void
}

export const ExpenseCategoryDeleteDialogController: FC<Props> = ({
	isOpen,
	setIsOpen,
	expenseCategory,
	onSuccess,
}) => {
	const { token } = useAuth()
	const [isLoading, setIsLoading] = useState(false)
	const [errorMessage, setErrorMessage] = useState<string | null>(null)

	const handleExpenseCategoryDelete = useCallback(async () => {
		try {
			setIsLoading(true)
			await expenseCategoryDeleteService({ id: expenseCategory.id }, token)
			setIsOpen(false)
			onSuccess && onSuccess()
		} catch (err) {
			setErrorMessage(getErrorMessage(err))
		} finally {
			setIsLoading(false)
		}
	}, [expenseCategory, setIsOpen, token, onSuccess])

	return (
		<DeleteItemDialog
			title={`Delete ExpenseCategory: ${expenseCategory.name}`}
			isOpen={isOpen}
			onCancel={() => {
				setIsOpen(false)
				setErrorMessage(null)
			}}
			onDelete={handleExpenseCategoryDelete}
			isLoading={isLoading}
			errorMessage={errorMessage}
		/>
	)
}
